module.exports = __webpack_public_path__ + "header-logo.svg?28fa236222e56241e7a2a7e4df893f25";


//////////////////
// WEBPACK FOOTER
// ./static/header-logo.svg
// module id = 49
// module chunks = 0